import { groupByValue } from "../util/Map";
export function getKeysAndTransliterations(lang) {
    const alphabet = Array.from(groupByValue(lang.alphabet));
    alphabet.sort((first, second) => first[0].localeCompare(second[0]));
    return alphabet.map(letter => {
        return { key: letter[0], transliterations: letter[1].reverse().join(", ") };
    });
}
